﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../utilities/crud-functions';
import { Document } from '../models/document';
import { ItemBasicInformation } from '../models/item-basic-information';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import { BenchSheetTechnologyType, DocumentType } from '../models/enums';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';

import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { RadioGroup } from 'devextreme-react';
import { TextBox } from 'devextreme-react';
import { confirm } from 'devextreme/ui/dialog';
import { IconTemplates } from '../templates/icon-templates';

const captureOptions = [{ id: 1, name: 'Browse file' }, { id: 2, name: 'Drag and drop' }];

export interface Props {
    parentId: string;
    technology?: BenchSheetTechnologyType;
    documentType?: DocumentType;
    readOnly?: boolean;
    canDelete?: boolean;
}

export default function DocumentLoader(props: Props) {
    const [documents, setDocuments] =
        useState<Document[]>();

    const [selectedDocument, setSelectedDocument] =
        useState<Document>();

    const [captureTypeId, setCaptureTypeId] =
        useState<number>(1);

    const [itemBasicInitInformation, setItemBasicInitInformation] =
        useState<ItemBasicInformation>();

    const [documentPreviewVisible, setDocumentPreviewVisible] =
        useState<boolean>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getDocuments();
    }, [props.parentId]);

    let fileLoadrCss = captureTypeId === 1 ? "visibleComponent" : "collapsedComponent";
    let dragndropCss = captureTypeId === 2 ? "visibleComponent" : "collapsedComponent";

    return (
        <div>
            {!props.readOnly &&
                <div>
                    <div id="image-capture-toolbar">
                        <div className="pw-margin-top-1 pw-margin-bottom-1">
                            <RadioGroup items={captureOptions} readOnly={props.readOnly}
                                valueExpr="id"
                                displayExpr="name"
                                onValueChanged={changeCaptureType}
                                value={captureTypeId}
                                layout="horizontal" />
                        </div>
                    </div>

                    <div className="file-reader-container">
                        <div className={fileLoadrCss}>
                            <div className="ic-player-frame">
                                <input type="file" id="file-input" onChange={onFileLoaderChange}></input>
                            </div>
                        </div>

                        <div className={dragndropCss}>
                            <div className="ic-player-frame">
                                <div id="ImageDnDTarget" className="ic-dnd-target"
                                    onDrop={onFileDrop}
                                    onDragOver={onFileDragOver}>
                                    <div className="ic-dnd-target-text">You can drag a document here</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <div className="imageCaptureThumbnailList">
                {documents && documents.map((doc) =>
                    <div className="imageCaptureThumb"
                        id={doc && doc.documentId}
                        onClick={selectedDocumentChanged}
                        key={doc && doc.documentId && doc.documentId.toString()}>
                        <div className="documentThumb">
                            <div>{IconTemplates.renderDocumentFileType(doc)}</div>
                            <div className="documentThumbText">{doc.name}</div>
                        </div>
                    </div>
                )}

            </div>

            {documentPreviewVisible &&
                <DialogPopup
                    visible={documentPreviewVisible}
                    onHiding={hideDocumentPreview}
                    dragEnabled={false}
                    resizeEnabled={false}
                    width={'40em'}
                    height={'30em'}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    title="Document Preview">
                    <div>
                        <div>
                            <div className="blob-preview-toolbar">
                                <div className="blob-preview-toolbar-file-name">{selectedDocument ? selectedDocument.name : "[unnamed]"}</div>
                                <div className="title-bar-spacer" />
                                <div >
                                    <div>
                                        <Button className="title-bar-button"
                                            text="" icon="info" type="success"
                                            hint="item information"
                                            onClick={onDocumentInfoButtonClick} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="form-unit">
                                <label className="textbox-label">Name</label>
                                <TextBox id="documentName"
                                    className="textbox" readOnly={props.readOnly}
                                    placeholder="NA"
                                    value={selectedDocument ? selectedDocument.name : undefined}
                                    onValueChanged={onDocumentNameChanged} />
                            </div>
                            <div className="form-unit">
                                <label className="textbox-label">Description</label>
                                <TextBox id="documentDescription" readOnly={props.readOnly}
                                    className="textbox"
                                    placeholder="NA"
                                    value={selectedDocument ? selectedDocument.description : undefined}
                                    onValueChanged={onDocumentDescriptionChanged} />
                            </div>
                        </div>

                        <div className="image-preview-buttons">
                            <Button id="saveImage" text="Save" icon="save" type="normal"
                                className="image-preview-button" disabled={props.readOnly}
                                onClick={onDocumentPreviewSave} />
                            {selectedDocument && selectedDocument.documentId &&
                                <Button id="downloadDocument" text="Download" icon="save" type="normal"
                                    className="image-preview-button"
                                    onClick={onDocumentDownload} />
                            }
                            {selectedDocument && selectedDocument.documentId &&
                                <Button id="deleteDocument" text="Delete" icon="trash" type="normal"
                                    className="image-preview-button" disabled={!props.canDelete}
                                    onClick={onDocumentDelete} />
                            }
                            <Button id="cancelDocument" text="Cancel" icon="arrowleft" type="normal"
                                className="image-preview-button"
                                onClick={onDocumentCancel} />
                        </div>
                    </div>
                </DialogPopup>
            }

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInitInformation}
                        onOkClick={hideItemBasicInformationDialog} />
                </DialogPopup>
            }

            {/*
            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
            */}
        </div>
    );

    function onDocumentNameChanged(e: any) {
        setSelectedDocument({ ...selectedDocument, name: e.value });
    }

    function onDocumentDescriptionChanged(e: any) {
        setSelectedDocument({ ...selectedDocument, description: e.value });
    }

    async function onDocumentPreviewSave() {
        if (selectedDocument) {
            //console.log("IN onDocumentPreviewSave()");
            //console.log(selectedDocument);

            if (!selectedDocument.documentId) {
                await insertDocument(selectedDocument)
                    .then(() => {
                        getDocuments();
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Inserting Document");
                    });
            }
            else {
                await updateDocument(selectedDocument)
                    .then(() => {
                        getDocuments();
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Document");
                    });
            }

            hideDocumentPreview();
        }
    }

    function onDocumentDelete() {
        const result = confirm("Are you sure you want to delete this document? This cannot be undone.", "Confirm Delete");
        result.then((dialogResult) => {
            if (dialogResult && selectedDocument && onDocumentDelete && selectedDocument.documentId)
                deleteDocument(selectedDocument.documentId)
                    .then(data => {
                        getDocuments();
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Deleting Document");
                    });
        });

        hideDocumentPreview();
    }

    function onDocumentCancel() {
        hideDocumentPreview();
    }

    function selectedDocumentChanged(e: any) {
        if (e.target) {
            var currentClassList = e.target.classList as DOMTokenList;

            let imageCaptureThumbElem;

            if (currentClassList.contains("imageCaptureThumb"))
                imageCaptureThumbElem = e.target;
            else
                imageCaptureThumbElem = e.target.closest(".imageCaptureThumb");

            //console.log("imageCaptureThumbElem");
            //console.log(imageCaptureThumbElem);

            if (imageCaptureThumbElem) {
                let id = imageCaptureThumbElem.id;

                if (documents) {
                    const filteredDocuments =
                        documents.filter(d => d.documentId === id);

                    if (filteredDocuments && filteredDocuments.length > 0) {
                        let editedDoc = filteredDocuments[0];

                        setSelectedDocument(editedDoc);
                        showDocumentPreview();
                    }
                }
            }
        }
    }

    function changeCaptureType(e: any) {
        setCaptureTypeId(e.value);
    }

    function onFileDragOver(e: any) {
        e.stopPropagation();
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
    }

    function onFileDrop(e: any) {
        e.stopPropagation();
        e.preventDefault();

        if (e.dataTransfer && e.dataTransfer.files) {
            let files = e.dataTransfer.files;

            if (files && files.length > 0) {
                let file = files[0];

                let doc: Document = {
                    name: file.name,
                    parentId: props.parentId,
                    kbSize: file.size,
                    mimeTypeString: file.type,
                    documentType: props.documentType
                };

                var reader = new FileReader();

                reader.onload = (event: any) => readFile(doc, event)
                    .then((doc) => {
                        setSelectedDocument(doc);
                        showDocumentPreview();
                    });

                reader.readAsDataURL(file);
            }
        }
    }

    async function onFileLoaderChange(e: any) {
        let files = e.target.files;

        if (files && files.length > 0) {
            let file = files[0];

            console.log(file);

            let doc: Document = {
                name: file.name,
                parentId: props.parentId,
                kbSize: file.size,
                mimeTypeString: file.type,
                documentType: props.documentType
            };

            var reader = new FileReader();

            reader.onload = (event: any) => readFile(doc, event)
                .then((doc) => {
                    setSelectedDocument(doc);
                    showDocumentPreview();
                });

            reader.readAsDataURL(file);
        }
    }

    async function readFile(doc: Document, event: any): Promise<any> {
        if (event && event.target && event.target.result)
            doc.base64Blob = event.target.result;
        return doc;
    }

    async function downloadDocument() {
        if (selectedDocument && selectedDocument.documentId) {
            let url = `media/document/${selectedDocument.documentId}`;

            await CrudFunctions.getDataBlob(url)
                .then((blob: any) => {
                    let a = document.createElement("a") as HTMLAnchorElement;

                    document.body.appendChild(a);
                    a.style.display = "none";

                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = selectedDocument.name ? selectedDocument.name : "file";
                    a.click();
                    window.URL.revokeObjectURL(url);

                    //to open PDF in browser:
                    // let file = window.URL.createObjectURL(blob);
                    // window.open(file, "_blank");
                });
        }
    }

    function onDocumentInfoButtonClick(e: any) {
        if (selectedDocument) {
            let doc = selectedDocument;

            let itemInformation: ItemBasicInformation = {
                rowPointer: doc.documentId,
                createTimestamp: doc.createTimestamp,
                lastModifiedTimestamp: doc.modifyTimestamp,
                createUser: doc.createUser,
                modifyUser: doc.modifyUser
            };

            setItemBasicInitInformation(itemInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    async function getDocuments() {
        //console.log("IN DocumentLoader; getDocuments()");
        //console.log(props.parentId);

        let url = '';

        if (props.parentId) {
            if (props.documentType)
                url = `media/documentmetadata/${props.parentId}/${props.documentType}`
            else
                url = `media/documentmetadatabyparentid/${props.parentId}`

            await CrudFunctions.getData(url)
                .then(data => {
                    setDocuments(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Documents");
                });
        }
    }

    async function insertDocument(document: Document) {
        return await CrudFunctions.postData("media/document", document);
    }

    async function updateDocument(document: Document) {
        return await CrudFunctions.putData("media/document", document);
    }

    // DELETE functions

    async function deleteDocument(documentId: string) {
        return await CrudFunctions.deleteData(`media/document/${documentId}`);
    }

    function showDocumentPreview() {
        setDocumentPreviewVisible(true);
    }

    function hideDocumentPreview() {
        setDocumentPreviewVisible(false);
    }

    function onDocumentDownload() {
        downloadDocument();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    /*
    renderDocumentFileType(doc: any) {
        switch (doc.mimeType) {
            case MimeType.Bmp:
            case MimeType.Gif:
            case MimeType.Jpeg:
            case MimeType.Png:
            case MimeType.Tiff:
                return <div className="image-thumb-icon-container"><i className="dx-icon-image image-thumb-icon pw-azure"></i></div>;

            case MimeType.Mp4:
            case MimeType.Mpeg:
                return <div className="image-thumb-icon-container"><i className="dx-icon-video image-thumb-icon pw-pink"></i></div>;

            case MimeType.Csv:
                return <div className="image-thumb-icon-container"><i className="dx-icon-txtfile image-thumb-icon pw-light-green"></i></div>;

            case MimeType.Pdf:
                return <div className="image-thumb-icon-container"><i className="dx-icon-pdffile image-thumb-icon pw-red"></i></div>;

            case MimeType.Html:
                return <div className="image-thumb-icon-container"><i className="dx-icon-globe image-thumb-icon pw-dark-purple"></i></div>;

            case MimeType.Json:
                return <div className="image-thumb-icon-container"><span className="material-symbols-outlined tab-icon pw-blue">data_object</span></div>;

            case MimeType.Xml:
                return <div className="image-thumb-icon-container"><i className="dx-icon-codeblock image-thumb-icon pw-green"></i></div>;

            case MimeType.Zip:
                return <div className="image-thumb-icon-container"><i className="dx-icon-image image-thumb-icon pw-light-green"></i></div>;

            case MimeType.MicrosoftExcel:
                return <div className="image-thumb-icon-container"><i className="dx-icon-xlsfile image-thumb-icon pw-green"></i></div>;

            case MimeType.MicrosoftExcelX:
                return <div className="image-thumb-icon-container"><i className="dx-icon-xlsxfile image-thumb-icon pw-green"></i></div>;

            case MimeType.MicrosoftWord:
                return <div className="image-thumb-icon-container"><i className="dx-icon-docfile image-thumb-icon pw-blue"></i></div>;

            case MimeType.MicrosoftWordX:
                return <div className="image-thumb-icon-container"><i className="dx-icon-docxfile image-thumb-icon pw-blue"></i></div>;

            case MimeType.MicrosoftPowerPoint:
                return <div className="image-thumb-icon-container"><i className="dx-icon-pptfile image-thumb-icon pw-orange"></i></div>;

            case MimeType.MicrosoftPowerPointX:
                return <div className="image-thumb-icon-container"><i className="dx-icon-pptxfile image-thumb-icon pw-orange"></i></div>;

            default:
                return <div className="image-thumb-icon-container"><i className="dx-icon-textdocument image-thumb-icon"></i></div>;
        }
    }
    */


}
